import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
	Container,
	Typography,
	Box,
	Button,
	InputAdornment,
	IconButton,
	TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Toast from '../../components/page/Toast/page';
import { AuthenticationAPI } from '../../services/api/Authentication';
import { StyledCheckbox } from '../../components/component/ThemeComponent';
// Create a styled TextField component
const StyledTextField = styled('input')({
	width: '100%', // Adjust width to account for padding
	padding: '8px', // Reduce padding
	marginTop: '8px',
	marginBottom: '16px',
	border: '1px solid #ccc',
	borderRadius: '4px',
	fontSize: '16px',
	boxSizing: 'border-box', // Include padding and border in element's total width and height
	'&:focus-visible': {
		outline: `2px solid #0C8040`,
	},
});

const LoginPage: React.FC = () => {
	const navigate = useNavigate();
	const [formValues, setFormValues] = useState({ email: '', password: '' });
	const [formErrors, setFormErrors] = useState({ email: '', password: '' });
	const [rememberMe, setRememberMe] = useState(false);
	const [loading, setLoading] = useState(false);
	const [alertMessage, setAlertMessage] = useState<string | null>(null);
	const [alertSeverity, setAlertSeverity] = useState<'success' | 'error' | 'info' | 'warning'>(
		'success'
	);
	const [showPassword, setShowPassword] = useState(false);

	const validate = () => {
		const errors = { email: '', password: '' };
		const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

		if (!formValues.email) {
			errors.email = 'Email is required';
		} else if (!emailPattern.test(formValues.email)) {
			errors.email = 'Invalid email format';
		}

		if (!formValues.password) {
			errors.password = 'Password is required';
		} else if (formValues.password.length < 8) {
			errors.password = 'Password must be at least 8 characters';
		}

		setFormErrors(errors);
		return Object.values(errors).every((error) => error === '');
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		setFormValues({ ...formValues, [name]: value });
	};

	const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRememberMe(event.target.checked);
	};

	const handleSubmit = async (event: React.FormEvent) => {
		event.preventDefault();
		setLoading(true);
		if (validate()) {
			try {
				const res = await AuthenticationAPI.Login(formValues);
				console.log(res, 'res');

				if (res?.isError) {
					// console.log('Error logging in user:', res);
					// alert(`Login failed: ${res.error.errors}`);
					setAlertMessage(res?.error?.errors);
					setAlertSeverity('error');
				} else if (res?.data?.success) {
					setAlertMessage('SuccessFully Login');
					setAlertSeverity('success');
					navigate('/');
					if (rememberMe) {
						localStorage.setItem('token', res?.data?.token);
						// setAlertMessage('SuccessFully Login');
						// setAlertSeverity('success');
						// navigate('/');
					} else {
						sessionStorage.setItem('token', res?.data?.token);
					}
				}
			} catch (error) {
				console.error('Failed to log in user:', error);
				alert(`Login failed: ${error instanceof Error ? error.message : String(error)}`);
			} finally {
				setLoading(false);
			}
		}
	};
	const handleClickShowPassword = () => {
		setShowPassword((prev) => !prev);
	};

	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: { xs: 'center', md: 'flex-end' }, // Align center for mobile and right for tab/desktop
				justifyContent: 'center',
				height: '100vh',
				backgroundImage: 'url("/assets/Group 26.png")',
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundAttachment: 'fixed', // Set background image as fixed
			}}
		>
			<Container
				component="main"
				maxWidth="xs"
				sx={{
					padding: '20px',
					borderRadius: '10px',
					backgroundColor: 'white',
					boxShadow: 3,
					overflowY: 'auto', // Enable vertical scrolling
					maxHeight: '90vh', // Limit the height of the container
				}}
			>
				<Box textAlign="center">
					<img
						src="/assets/CHAKARAVARTHY CATERING - FINAL LOGO DESIGN 1.png"
						alt="Login Logo"
						style={{ width: '100px', height: 'auto' }}
					/>
				</Box>

				<form onSubmit={handleSubmit}>
					<Box mb={0}>
						<label htmlFor="email">Email Id</label>
						<StyledTextField
							id="email"
							name="email"
							type="email"
							value={formValues.email}
							onChange={handleChange}
							placeholder="Email"
						/>
						{formErrors.email && (
							<Typography variant="caption" color="error" sx={{ color: 'red' }}>
								{formErrors.email}
							</Typography>
						)}
					</Box>
					<Box mb={0}>
						<label htmlFor="password">Password</label>
						{/* <StyledTextField
							id="password"
							name="password"
							type="password"
							value={formValues.password}
							onChange={handleChange}
							placeholder="Password"

						/> */}
						<TextField
							size="small"
							id="password"
							name="password"
							type={showPassword ? 'text' : 'password'}
							value={formValues.password}
							onChange={handleChange}
							placeholder="Password"
							fullWidth
							margin="dense"
							variant="outlined"
							slotProps={{
								input: {
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												aria-label={
													showPassword
														? 'hide the password'
														: 'display the password'
												}
												onClick={handleClickShowPassword}
												onMouseDown={handleMouseDownPassword}
												edge="end"
											>
												{showPassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									),
								},
							}}
						/>
						<Typography variant="caption" color="error">
							{alertMessage}
						</Typography>
						{formErrors.password && (
							<Typography variant="caption" color="error" sx={{ color: 'red' }}>
								{formErrors?.password}
							</Typography>
						)}
					</Box>
					<Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
						<Box display="flex" alignItems="center">
							<StyledCheckbox
								type="checkbox"
								id="rememberMe"
								checked={rememberMe}
								onChange={handleCheckboxChange}
							/>
							<label
								htmlFor="rememberMe"
								style={{ marginLeft: '2px', color: '#7C7575', fontSize: '12px' }}
							>
								Remember Me
							</label>
						</Box>
						{/* <Button
							variant="text"
							onClick={() => navigate('/forgot-password')}
							sx={{ textTransform: 'none', color: '#CA0005', fontFamily: 'Poppins' }}
						>
							Forgot Password?
						</Button> */}
					</Box>
					<section style={{ textAlign: 'center' }}>
						<Button
							type="submit"
							variant="contained"
							sx={{
								width: '80%',
								backgroundColor: '#CA0005',
								color: 'white',
								fontFamily: 'Poppins',
								borderTopLeftRadius: '20px',
								borderTopRightRadius: '20px',
								borderBottomLeftRadius: '20px',
								borderBottomRightRadius: '20px',
							}}
							loading={loading}
							loadingIndicator={'Loading...'}
						>
							Login
						</Button>
					</section>
				</form>
			</Container>
			<Toast
				alertSeverity={alertSeverity}
				alertMessage={alertMessage}
				setAlertMessage={setAlertMessage}
			/>
		</Box>
	);
};

export default LoginPage;
